module.exports = __webpack_public_path__ + "img/banner2.10b87d7c.jpg";